import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export const userService = {
  // 사용자 정보를 Firestore에 저장
  createUserDocument: async (userId, userData) => {
    try {
      const userRef = doc(db, 'users', userId);
      await setDoc(userRef, {
        ...userData,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      return true;
    } catch (error) {
      console.error('Error creating user document:', error);
      throw new Error('사용자 정보 저장에 실패했습니다.');
    }
  },

  // 사용자 정보 가져오기
  getUserDocument: async (userId) => {
    try {
      const userRef = doc(db, 'users', userId);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        return { id: userDoc.id, ...userDoc.data() };
      }
      return null;
    } catch (error) {
      console.error('Error getting user document:', error);
      throw new Error('사용자 정보를 가져오는데 실패했습니다.');
    }
  },

  // 사용자 정보 업데이트
  updateUserDocument: async (userId, updateData) => {
    try {
      const userRef = doc(db, 'users', userId);
      await setDoc(userRef, {
        ...updateData,
        updatedAt: serverTimestamp(),
      }, { merge: true });
      return true;
    } catch (error) {
      console.error('Error updating user document:', error);
      throw new Error('사용자 정보 업데이트에 실패했습니다.');
    }
  },
};
